// extracted by mini-css-extract-plugin
export default {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__4RM7y","Question":"ActiveQuiz_Question__JV0IQ"};